import {
  FETCH_AUTH_USER,
  SET_AUTH_USER_SIDEBAR,
  SET_AUTH_USER_AVATAR,
} from '../actions/authAction';

const initialState = {
  user: null,
  settings: {
    layout: {},
    custom: {},
  },
  permissions: null,
  customStates: null,
  languages: null,
  maintenance: false,
};
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AUTH_USER: {
      return {
        ...state,
        user: action.payload.user,
        settings: action.payload.settings,
        permissions: action.payload.permissions,
        customStates: action.payload.customStates,
        languages: action.payload.languages,
        languageVariants: action.payload.languageVariants,
        maintenance: action.payload.maintenance,
      };
    }
    case SET_AUTH_USER_SIDEBAR: {
      const { option, value } = action.payload;

      return {
        ...state,
        settings: {
          ...state.settings,
          layout: {
            ...state.settings.layout,
            [option]: value,
          },
        },
      };
    }
    case SET_AUTH_USER_AVATAR: {
      return {
        ...state,
        user: {
          ...state.user,
          avatar: action.payload,
        },
      };
    }
    default:
      return state;
  }
};
export default authReducer;
